
import { useState } from "react";
import a1 from "../imgs/logo.jpg"
import { useNavigate } from "react-router-dom";

const NavBar = () => {
    const nav = useNavigate('');
    return (
        <>
        <div className="nav-wrapper">
            <nav className="navbar navbar-expand-lg spple">
                <div className="container-fluid">
                    <a onClick={()=>nav('/')} className="navbar-brand" href="#"> <div className="log">
                        <h3> <i class="fa-solid fa-camera-retro"></i> WEB </h3>
                    </div></a>
                      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    </div>
            </nav>
             </div>

        </>
    )
}

export default NavBar;